
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

export interface GoalContactItemProps {
  variant?: 'standalone' | 'monitoring';
}

const GoalContactItem = ({
  variant = 'standalone',
}: GoalContactItemProps): React.JSX.Element => {
  const handleEmailClick = (): void => {
    window.location.href = 'mailto:clientsupport@marketviewedu.com';
  };

  return (
    <Stack
      sx={[
        {
          width: '100%',
          bgcolor: 'tokens.navy.800',
          color: 'common.white',
          borderRadius: '0.375rem',
          alignItems: 'center',
        },
        variant === 'monitoring' ? { p: 2.5, mt: 3 } : { py: 4, px: 2, mt: 5 },
      ]}
      data-testid="goal-contact-item"
    >
      <h2 className="text-xl font-bold mb-2" data-testid="goal-contact-heading">
        Are your goals missing?
      </h2>
      <p className="mb-4 text-navy-100" data-testid="goal-contact-description">
        Contact your Client Success Team to discuss your priorities and ensure
        your goals are fully aligned and up to date.
      </p>
      <Button
        variant="brand-filled"
        size="sm"
        onClick={handleEmailClick}
        data-testid="goal-contact-button"
      >
        {variant === 'monitoring' ? 'Speak with Us' : 'Speak to Us'}
      </Button>
    </Stack>
  );
};

export default GoalContactItem;
